import { apiInterceptor } from 'utils/apiInterceptor';
export const signup = async (payload, channel = '', recaptchaToken = '', recaptchaAction = '') => {
    let api = `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/email`;
    if (channel)
        api = `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/${channel}`;
    const response = await apiInterceptor(api, {
        method: 'POST',
        headers: {
            'x-api-key': process.env.REACT_APP_X_API_KEY,
            'Content-Type': 'application/json',
            'recaptcha-token': recaptchaToken,
            'recaptcha-action': recaptchaAction,
        },
        body: JSON.stringify(payload),
    });

    return await response.json();
};

export const validatePromo = async (promo) => {
    const  response  = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/validate-promo`,
        {
            method: 'POST',
            headers: {
                'x-api-key': process.env.REACT_APP_X_API_KEY,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ promo }),
            ignoreResponseValidation: true,
        }
    );

    try {
        return await response.json();
    } catch (error) {
        return {
            status: false,
            message: 'Invalid promo code',
        };
    }
};

export const validateSignupOtp = async (payload) => {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/validate`,
        {
            method: 'POST',
            headers: {
                'x-api-key': process.env.REACT_APP_X_API_KEY,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }
    );

    return await response.json();
};

export const updateSignupData = async (id, payload, recaptchaToken = '', recaptchaAction = '') => {
    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API_V2}/manager/livestream/accounts/${id}`,
        {
            method: 'PUT',
            headers: {
                'x-api-key': process.env.REACT_APP_X_API_KEY,
                'Content-Type': 'application/json',
                'recaptcha-token': recaptchaToken,
                'recaptcha-action': recaptchaAction,
            },
            body: JSON.stringify(payload),
        }
    );

    return await response.json();
};
